export enum WorkflowTriggerTypes {
  INCIDENT_RESOLVED = 'incident_resolved',
  INCIDENT_ACKNOWLEDGED = 'incident_acknowledged',
  INCIDENT_TRIGGERED = 'incident_triggered',
  INCIDENT_REASSIGNED = 'incident_reassigned',
  INCIDENT_TAGS_UPDATED = 'incident_tag_updated',
  INCIDENT_PRIORITY_UPDATED = 'incident_priority_updated',
  INCIDENT_NOTE_ADDED = 'incident_note_added',
}
